import React, { useEffect, useState } from "react";
import useSave from "../../Hooks/useSave";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import Table from "./../../Components/Table";
import useUpdate from "../../Hooks/useUpdate";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Api from "../../Hooks/Api";
const KpiTarget = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);
  const [contractsOptions, setContractsOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [update, setUpdate] = useState(false);
  const url = "api/kpis";
  const { state, FetchAll } = useFetch(url);

  const fetchContracts = async () => {
    try {
      Api.get("/api/contracts")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setContractsOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchProject = async () => {
    try {
      Api.get("/api/projects")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setProjectOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
    fetchProject();
    fetchContracts();
  }, []);

  const handleOpenModal = (event) => {
    event.persist();
    setInputs({});
    setOpen(true);
  };

  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = () => {
    if (inputs.targetId) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleView = () => {
    if (inputs.targetId) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };
  const handleSelect = (k, event) => {
    setInputs({});
    setInputs(k);
  };
  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
  };

  const HandleSubmit = (event) => {
    event.preventDefault();
    useSave(url, inputs);
  };
  const CallDeletehook = () => {
    useDelete(url + "/delete?id=" + inputs.targetId);
  };
  const HandelDelete = () => {
    if (inputs.targetId) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const ColumnData = [
    {
      label: "Id",
      field: "targetId",
      sort: "asc",
    },
    {
      label: "Contract",
      field: "contract",
      sort: "asc",
    },
    {
      label: "Project",
      field: "project",
      sort: "asc",
    },
    {
      label: "Indicator Description",
      field: "indicatorDescription",
      sort: "asc",
    },
    {
      label: "Weight",
      field: "weight",
      sort: "asc",
    },
    {
      label: "Annual Target",
      field: "annualTarget",
      sort: "asc",
    },
    {
      label: "q1Target",
      field: "q1Target",
      sort: "asc",
    },
    {
      label: "q2Target",
      field: "q2Target",
      sort: "asc",
    },
    {
      label: "q3Target",
      field: "q3Target",
      sort: "asc",
    },
    {
      label: "q4Target",
      field: "q4Target",
      sort: "asc",
    },
  ];
  let Rowdata1 = [];
  const rows = state.data;
  if (rows.length > 0) {
    rows.forEach((k) => {
      const Rowdata = {
        clickEvent: () => handleSelect(k),
        contract: k.contract.staff.fullName,
        project: k.project.title,
        indicatorDescription: k.indicatorDescription,
        weight: k.weight,
        annualTarget: k.annualTarget,
        q1Target: k.q1Target,
        q2Target: k.q2Target,
        q3Target: k.q3Target,
        q4Target: k.q4Target,
        targetId: k.targetId,
        targetId: k.targetId,
      };
      Rowdata1.push(Rowdata);
    });
  }

  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">STAFF KPI TARGETS</li>
      </ol>
      <h1 class="page-header mb-3">STAFF KPI TARGETS</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            <button
              onClick={handleOpenModal}
              className="btn btn-primary p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              New
            </button>
            <button
              onClick={handleView}
              className="btn btn-success p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              View
            </button>
            <button
              onClick={handleEdit}
              className="btn btn-info p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Edit
            </button>
            <button
              onClick={HandelDelete}
              className="btn btn-danger p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Delete
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={Rowdata1} columns={ColumnData} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="60%" height="75%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
            {view ? null : (
              <div className="col-sm-4 fontWeight-bold text-blue">
                STAFF KPI TARGETS
              </div>
            )}
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                {view ? (
                  <div>
                    <h3> STAFF KPI TARGETS</h3>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td className="font-weight-bold">Contract:</td>
                          <td>
                            {inputs.contract
                              ? inputs.contract.staff.fullName
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Project:</td>
                          <td>
                            {inputs.project ? inputs.project.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Indicator Description:
                          </td>
                          <td>{inputs.indicatorDescription}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Weight as a % Percentage:
                          </td>
                          <td>{inputs.weight}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Annual Target:</td>
                          <td>{inputs.annualTarget}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">q1 Target:</td>
                          <td>{inputs.q1Target}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">q2 Target:</td>
                          <td>{inputs.q2Target}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">q3 Target:</td>
                          <td>{inputs.q3Target}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">q4 Target:</td>
                          <td>{inputs.q4Target}</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div className="row">
                      <div class="d-flex flex-row ">
                        <button
                          className="btn btn-primary p-2"
                          type="button"
                          onClick={handleEdit}
                        >
                          Update
                        </button>
                        &nbsp;
                        <button
                          onClick={HandelDelete}
                          className="btn btn-danger p-2"
                        >
                          Delete
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <br />
                  </div>
                ) : (
                  <form className="form-horizontal" onSubmit={HandleSubmit}>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Performance Contract Staff
                          </label>
                          <select
                            className="form-control"
                            name="contractId"
                            required
                            value={inputs.contractId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Contract</option>
                            {contractsOptions &&
                              contractsOptions.map((types) => (
                                <option
                                  key={types.contractId}
                                  value={types.contractId}
                                >
                                  {types.staff.fullName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Project
                          </label>
                          <select
                            className="form-control"
                            name="projectId"
                            required
                            value={inputs.projectId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Project</option>
                            {projectOptions &&
                              projectOptions.map((types) => (
                                <option
                                  key={types.projectId}
                                  value={types.projectId}
                                >
                                  {types.title}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="indicatorDescription"
                            className="fontWeight-bold"
                          >
                            Indicator Description
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="indicatorDescription"
                            required
                            value={inputs.indicatorDescription}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="weight" className="fontWeight-bold">
                            Weight as a % Percentage
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="weight"
                            required
                            value={inputs.weight}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Annual Target
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="annualTarget"
                            required
                            value={inputs.annualTarget}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                    </div>

                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="q1Target" className="fontWeight-bold">
                            q1 Target
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="q1Target"
                            required
                            value={inputs.q1Target}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="q2Target" className="fontWeight-bold">
                            q2 Target
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="q2Target"
                            required
                            value={inputs.q2Target}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="q3Target" className="fontWeight-bold">
                            q3 Target
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="q3Target"
                            required
                            value={inputs.q3Target}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="q2Target" className="fontWeight-bold">
                            q4 Target
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="q4Target"
                            required
                            value={inputs.q4Target}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm">
                        <div className="row">
                          <div className="col-sm-12">
                            <div class="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default KpiTarget;
